export default __webpack_public_path__ + "static/media/refine.inline.f5a1d994.svg";